export var CHINA_ID = 48;
export default CHINA_ID;